import Alert from "./Alert";

const AlertModal = {
  install(Vue) {
    this.EventBus = new Vue();
    Vue.component("Alert", Alert);
    Vue.prototype.$alert = {
      show(params, title, callback, seconButtontext, secodCallBack) {
        AlertModal.EventBus.$emit("show", params, title, callback, seconButtontext, secodCallBack);
      },
      hide() {
        AlertModal.EventBus.$emit("hide");
      },
    };
  },
};

export default AlertModal;
